module.exports = __webpack_public_path__ + "static/media/2-2.fd6dd89a.mp3";